import { Component } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';


@Component({
  host: { 'test-id': 'session-timeout-error' },
  selector: 'session-timeout-error',
  template: `
    <fw-layout-context
      title="{{ 'sessionTimeout.title' | translate }}"
      description="{{ 'sessionTimeout.message' | translate }}"
      icon="warning-circle"
      iconColor="danger"
    >
      <fw-button (click)="login()" variant="outline" leftIcon="rotate-refresh" size="large">{{'common.actions.login' | translate}}</fw-button>
    </fw-layout-context>
  `,
  styles: [`
    :host {
      width: 100vw;
      height: 100vh;
      background: var(--page-light);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  `],
})
export class SessionTimeoutErrorComponent {

  constructor(
    private auth0: Auth0Service,
  ){}

  login(): void {
    this.auth0.loginWithRedirect({ authorizationParams: { prompt: 'login' } })
  }
}
